// import ComponentA from './Components/ComponentA'
import HiddenVersion from './components/HiddenVersion'
import Loading from './components/Loading'
import Menu from './Components/Menu'
import SumFields from './components/SumFields'
import Upload from './Components/Upload'
import DownloadManager from './components/DownloadManager'
import Delete from './components/Delete'
import UploadDynamic from './components/UploadDynamic'
import WIP from './components/WIP'
import LinkConfirmManager from './components/LinkConfirmManager'
import UploadFiles from './components/UploadFiles'
import ExternalFetch from './components/ExternalFetch'
import ExternalFetchAll from './components/ExternalFetchAll'

document.addEventListener('DOMContentLoaded', () => {
    let root = {}
    root.loading = new Loading(root, [])
    root.loading.run()
    root.loading.show()

    root.menu = new Menu(root, [])
    root.menu.run()

    root.hiddenVersion = new HiddenVersion(root, [])
    root.hiddenVersion.run()

    root.upload = new Upload(root, [])
    root.delete = new Delete(root, [])
    root.sumFields = new SumFields(root, [])
    root.downloadManager = new DownloadManager(root, [])

    root.UploadDynamic = new UploadDynamic(root, [])
    root.LinkConfirmManager = new LinkConfirmManager(root, [])
    new UploadFiles();

    new WIP();
    new ExternalFetch();
    new ExternalFetchAll();
}, false)